import type { i18n as I18n } from "i18next";
import en from "@/locales/en/games/snake.json";
import fr from "@/locales/fr/games/snake.json";

export const SNAKE_NS = "games/snake";

/** Adds this game's translations to an initialised i18next instance (idempotent). */
export function registerSnakeTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SNAKE_NS))
    i18n.addResourceBundle("en", SNAKE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SNAKE_NS))
    i18n.addResourceBundle("fr", SNAKE_NS, fr, true, true);
}
